// Stub for cart context
import { createContext, useContext } from 'react';

const CartContext = createContext([
    {
        cartId: null,
        isAddingItem: false,
        cart: { items: [] }
    },
    {
        addItemToCart: () => {},
        removeItemFromCart: () => {},
        updateItemInCart: () => {}
    }
]);

export const useCartContext = () => useContext(CartContext);
export const CartContextProvider = CartContext.Provider;
export default CartContext;
